document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('.service-flow__text-outer').style.maxHeight = getVisibleHeight() + 'px';
  document.querySelector('.service-flow__more--display').addEventListener('click', (event) => {
    if (!event.target.classList.contains('service-flow__more--display')) return;

    document.querySelector('.service-flow__text-outer').style.maxHeight = getInnerHeight() + 'px';

    document.querySelectorAll('.service-flow__gradient').forEach((el) => {
      el.style.display = 'none';
    });

    event.target.style.display = 'none';

    document.querySelector('.service-flow__more--hidden').style.display = 'flex';
  });

  document.querySelector('.service-flow__more--hidden').addEventListener('click', (event) => {
    if (!event.target.classList.contains('service-flow__more--hidden')) return;

    document.querySelector('.service-flow__text-outer').style.maxHeight = getVisibleHeight() + 'px';

    document.querySelectorAll('.service-flow__gradient').forEach((el) => {
      el.style.display = 'block';
    });

    event.target.style.display = 'none';

    document.querySelector('.service-flow__more--display').style.display = 'flex';
  });
});

// .service-flow__text-item の要素3つ目までの高さを取得
function getVisibleHeight() {
  const items = document.querySelectorAll('.service-flow__text-item');
  let height = 0;

  for (let i = 0; i < 3; i++) {
    height += items[i].clientHeight;
  }

  return height;
}

function getInnerHeight() {
  const item = document.querySelector('.service-flow__text-inner');
  return item.clientHeight;
}

// PC のみ: kv__floating（kv_text_pc + auth-container）を画面右下に追従させ、
// project セクションに入ったあたりで kv_text_pc の画像を黒版に切り替える
document.addEventListener('DOMContentLoaded', () => {
  initKvFollow();
});

function initKvFollow() {
  const floating = document.querySelector('.kv__floating');
  if (!floating) return;

  const pcMql = window.matchMedia('(min-width: 768px)');
  const textEl = floating.querySelector('.kv__text');
  const project = document.querySelector('.project');
  // テキストが重なっている間は白版に戻す暗い背景セクション
  const lightSections = ['.concept', '.sns', '.footer'].map((s) => document.querySelector(s)).filter(Boolean);
  const FIXED_BOTTOM = 100; // 追従時に固定する画面下からの位置（px）

  // kv 内に absolute 配置されている本来位置（ドキュメント基準の下端座標）
  let naturalBottom = 0;

  function measure() {
    floating.classList.remove('is-fixed');
    const rect = floating.getBoundingClientRect();
    naturalBottom = rect.bottom + (window.scrollY || window.pageYOffset);
  }

  function update() {
    if (!pcMql.matches) {
      floating.classList.remove('is-fixed');
      if (textEl) textEl.classList.remove('is-dark');
      return;
    }

    // 本来位置の下端が画面下 100px のラインまで上がってきたら fixed で追従
    const scrollY = window.scrollY || window.pageYOffset;
    const screenBottom = naturalBottom - scrollY;
    floating.classList.toggle('is-fixed', screenBottom <= window.innerHeight - FIXED_BOTTOM);

    // テキストの下端が project セクション上端に達したら黒版へ（白黒2枚を opacity で切替）。
    // ただしテキストが .concept / .sns / .footer（暗い背景）に重なっている間は白版に戻す
    if (textEl && project) {
      const textRect = textEl.getBoundingClientRect();
      const reached = project.getBoundingClientRect().top <= textRect.bottom;
      const overLight = lightSections.some((sec) => {
        const r = sec.getBoundingClientRect();
        return r.top < textRect.bottom && r.bottom > textRect.top;
      });
      textEl.classList.toggle('is-dark', reached && !overLight);
    }
  }

  measure();
  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', () => {
    measure();
    update();
  });
  window.addEventListener('load', () => {
    measure();
    update();
  });
}
